import { useSnackbar } from 'notistack'
import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { getAxiosInstance } from '../../../../../../../../helpers/get_axios_instance'
import { lrsAdapter } from '../../../../../../../../helpers/lrs_adapter'
import { closeDialog } from '../../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { actualizarEstadoSilos } from '../../../../../../actions'
import { OperacionNuevoTransileView } from '../components/OperacionNuevoTransileView'

const transilar = async (siloOrigen, siloDestino) => lrsAdapter(await getAxiosInstance().post(
  '/operacion_transile_silos', { valores: { silo_origen: siloOrigen.trim(), silo_destino: siloDestino.trim() } }))

export const OperacionNuevoTransile = connect(null, { closeDialog, actualizarEstadoSilos })(
  memo(({ silo: { nombreCorto: siloOrigen, cereal, cerealVariedad: variedad }, closeDialog, actualizarEstadoSilos }) => {
    const { enqueueSnackbar } = useSnackbar()
    return (
      <OperacionNuevoTransileView
        cereal={cereal}
        variedad={variedad}
        siloOrigen={siloOrigen}
        aceptar={async ({ siloDestino }) => {
          try {
            await transilar(siloOrigen, siloDestino)
            closeDialog()
            enqueueSnackbar('Transile correcto')
            actualizarEstadoSilos()
          } catch (error) {
            enqueueSnackbar('Transile incorrencto', { variant: 'error' })
          }
        }}
        cancelar={useCallback(() => {
          closeDialog('TRANSILE_SILO')
        }, [closeDialog])}
      />
    )
  })
)
